import { useRef } from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import './HeroSectionSlider.css';

const HeroSectionSlider = () => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const slides = [
        { image: '/Assets/SliderIamges/MS1.jpg'},
        { image: '/Assets/SliderIamges/MS2.jpg'},
        {image: '/Assets/SliderIamges/MS3.jpg' }, 
        {image: '/Assets/SliderIamges/MS4.jpg' },
        { image: '/Assets/SliderIamges/MS5.jpg' },
        { image: '/Assets/SliderIamges/MS6.jpg' },    
        { image: '/Assets/SliderIamges/MS7.jpg' },
    ];                                                        

    return (
        <div className="hero-slider">
            <Swiper
                modules={[Navigation, Autoplay]}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                loop
                speed={200}
                slidesPerView={1}
                navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                }}
                onInit={(swiper) => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                    swiper.navigation.init();
                    swiper.navigation.update();
                }}
            >
                {slides.map((slide, index) => (
                    <SwiperSlide key={index}>
                        <div className="slide">
                            <img src={slide.image} alt={`Slide ${index + 1}`} draggable="false" />
                        </div>
                    </SwiperSlide>
                ))}

                <div className="custom-swiper-button-prev" ref={prevRef}>‹</div>
                <div className="custom-swiper-button-next" ref={nextRef}>›</div>
            </Swiper>
        </div>
    );
};

export default HeroSectionSlider;